// 行程 id 生成（掉落/揭晓幂等外键）。
// 优先用 crypto.randomUUID（浏览器 / 现代 Node 均可用）；缺失时退化为时间戳 + 随机，
// 保证任何环境都能产出唯一 id。本文件属 src/core，可调用 Date.now / Math.random（仅 domain 层受限）。
export function newTripId(): string {
  const c = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  return `trip-${Date.now()}-${Math.floor(Math.random() * 1e9)}`;
}

// 🆕 v2：通用 uuid 生成（明信片条目 id 用）。
export function newId(): string {
  const c = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  return `id-${Date.now()}-${Math.floor(Math.random() * 1e9)}`;
}
